module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAUCAYAAACeXl35AAABOUlEQVRIS2NkIBN8P7J1+l82hkYeM+8XpBjBSIpiZLU/jm69+Z/hPz8jA1Mch7XXLmLNochCBgYGNQaG//8YGRk72X5y1TE6Ov4hZDEVLIRY8Z/h/7H///5Fctn6PcJnKeOHw1sECbkKmzwHE+NpBgYGZWQ5RgaGdwwMDEns1t4bcZnJ+OPo1v/kWIhHD8i8yewCX0sZtcN+oaujhYVgOxgZGc7+Z2CO4LDyuIMSCjTwIdx8RgaGT38ZGTK4rLyXwwRp5kO0oJzz7t2/fClf32/0spDhPyPDKk4r73D6WPifYe679//y6ODD/58ZGRnT2ekTh//PMTCyhNMjleLPh/8P7ZAkJ+P/ZP57hIGBQYnkkoYcy0B6QLUFpPAmsSyl3ML///7//9/F8Zunlua1BV3rQ7rX+ORGBQC7QpgVKoorAgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/public_icon_pronext.png
// module id = FyK+
// module chunks = 1